import React, {useCallback, useState} from 'react';
import BtnNewItem from "../../../simple/Buttons/BtnNewItem/BtnNewItem";
import NModal from "../../../simple/Modals/NModal/NModal";
import text from "../../../../services/localization/text";
import DocumentUploaderContent from "../DocumentUploader/DocumentUploaderContent";
import api from "../../../../services/apiInstance/api";
import apiErrorHandler from "../../../../services/apiInstance/apiErrorHandler";
import {hasAnyDuplicates} from "../../../../utils/checkDocumentNameDuplicate";
import createRenamedFile from "../../../../utils/createRenamedFile";

const TemplateUploader = ({organizationId, onTemplateUploaded, existingTemplates = []}) => {
  const [modalIsShown, setModalIsShown] = useState(false);
  const [errors, setErrors] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [documents, setDocuments] = useState([]);

  const showModal = useCallback(() => {
    setModalIsShown(true);
  }, []);

  const hideModal = useCallback(() => {
    setDocuments([]);
    setErrors({});
    setModalIsShown(false);
  }, []);

  const hasDuplicates = useCallback((documentsToCheck) => {
    return hasAnyDuplicates(documentsToCheck, existingTemplates);
  }, [existingTemplates]);

  const uploadDocuments = useCallback(async (documentsToUpload) => {
    setIsUploading(true);
    try {
      if (documentsToUpload.length) {
        const formData = new FormData();
        for (let i = 0; i < documentsToUpload.length; i++) {
          const doc = documentsToUpload[i];
          // Если имя файла было изменено, создаем новый File объект с новым именем
          const fileToUpload = doc.name !== doc.file.name 
            ? createRenamedFile(doc.file, doc.name)
            : doc.file;
          formData.append('file', fileToUpload);
          formData.append('description', doc.fileDescription);
        }

        const {data} = await api.uploadOrganizationTemplate(organizationId, formData);
        onTemplateUploaded(data);
      }
      hideModal();
    } catch (error) {
      const errorData = apiErrorHandler(error);
      setErrors({submit: errorData.message || 'Ошибка при загрузке файла'});
    } finally {
      setIsUploading(false);
    }
  }, [organizationId, onTemplateUploaded, hideModal]);

  const handleTemplateUploaded = useCallback(async () => {
    if (!documents.length) {
      return;
    }

    if (hasDuplicates(documents)) {
      return;
    }

    await uploadDocuments(documents);
  }, [documents, hasDuplicates, uploadDocuments]);

  return (
    <>
      <BtnNewItem
        onClick={showModal}
      >
        {text.uploadAvailableTemplate || "Загрузить шаблон"}
      </BtnNewItem>

      {modalIsShown && (
        <NModal
          isModalActionBtnDisabled={isUploading || hasDuplicates(documents)}
          modalTitle={text.uploadAvailableTemplate || "Загрузить шаблон"}
          modalCancelBtnText={text.cancel}
          modalActionBtnText={text.upload || "Загрузить"}
          onModalCancelBtnClick={hideModal}
          onModalActionBtnClick={handleTemplateUploaded}
        >
          <DocumentUploaderContent
            isAddAgreementMode
            itemId={organizationId}
            itemType={'organizations'}
            isMultipleUpload
            onDocumentsArrUpdate={(documentsArr) => {
              setDocuments(documentsArr)
            }}
            documentsArr={documents}
            existingTemplates={existingTemplates}
            onDocumentNameChange={(index, newName) => {
              setDocuments(prevDocuments => {
                const updatedDocuments = prevDocuments.map((doc, i) => 
                  i === index ? { ...doc, name: newName } : doc
                );
                return updatedDocuments;
              });
            }}
          />
          {errors.submit && <span className="input-bottom-error">{errors.submit}</span>}
        </NModal>
      )}
    </>
  );
};

export default TemplateUploader;
